import { Link } from "react-router-dom";
import { IconInstagram, IconWhatsApp } from "./Icons";

const Footer = ({ brandOptions }) => (
  <footer className="footer">
    <div className="footer-inner">
      <div>
        <div className="footer-brand">
          Legacy Timepieces<span>Luxury Watch Specialist</span>
        </div>
        <p className="footer-desc">
          Trusted by thousands of loyal customers since our opening in 2015, Legacy Timepieces draws on the combined experience of three generations of family ownership to curate authentic luxury timepieces from the world's most prestigious brands.
        </p>
        <div className="footer-social">
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconInstagram />
          </a>
          <a
            href="https://wa.me/6285178228989"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconWhatsApp />
          </a>
        </div>
      </div>
      <div>
        <div className="footer-heading">Quick Links</div>
        <div className="footer-links">
          <Link to="/" style={{ textDecoration: "none" }}>
            Home
          </Link>
          <Link to="/watches" style={{ textDecoration: "none" }}>
            All Watches
          </Link>
          <Link to="/watches?filter=men/unisex" style={{ textDecoration: "none" }}>
            Men's Collection
          </Link>
          <Link to="/watches?filter=women" style={{ textDecoration: "none" }}>
            Women's Collection
          </Link>
          <Link to="/watches?filter=new" style={{ textDecoration: "none" }}>
            New
          </Link>
          <Link
            to="/watches?filter=pre-owned"
            style={{ textDecoration: "none" }}
          >
            Pre-Owned
          </Link>
        </div>
      </div>
      <div>
        <div className="footer-heading">Brands</div>
        <div className="footer-links">
          {brandOptions.slice(0, 6).map((brand, index) => (
            <Link
              key={index}
              to={`/watches?brand=${encodeURIComponent(brand.name)}`}
              style={{ textDecoration: "none" }}
            >
              {brand.name}
            </Link>
          ))}
        </div>
      </div>
      <div>
        <div className="footer-heading">Services</div>
        <div className="footer-links">
          <Link to="/services?tab=buy" style={{ textDecoration: "none" }}>
            Buy a Watch
          </Link>
          <Link to="/services?tab=sell" style={{ textDecoration: "none" }}>
            Sell Your Watch
          </Link>
          <Link to="/services?tab=trade" style={{ textDecoration: "none" }}>
            Trade-In
          </Link>
          <Link
            to="https://legacytimepieces.id/services?tab=watch-service"
            style={{ textDecoration: "none" }}
          >
            Watch service
          </Link>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <span>
        © {new Date().getFullYear()} Legacy Timepieces. All rights reserved.
      </span>
      <span>Luxury Watch Specialist • Jakarta, Indonesia</span>
    </div>
  </footer>
);

export default Footer;
